import Grid from "@mui/material/Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ValidatedTextField from "../../../Utilities/Forms/ValidatedTextField";
import DataContainer from "../../../Utilities/DataContainer";

interface IProps {
    isReadOnly: boolean;
    landuse: string;
    subuse: string;
}

export default function OpeningTimes({ isReadOnly, landuse, subuse }: IProps) {
    return (
        ((
            (landuse === "01" && !"RS".includes(subuse)) ||
            landuse === "02" ||
            landuse === "04" ||
            landuse === "05" ||
            (landuse === "06" && !"L".includes(subuse)) ||
            landuse === "07" ||
            landuse === "08" ||
            (landuse === "09" && "ABCDEFGH".includes(subuse)) ||
            landuse === "10" ||
            landuse === "11" ||
            (landuse === "12" && "AC".includes(subuse)) ||
            (landuse === "13" && "ABC".includes(subuse)) ||
            landuse === "14" ||
            landuse === "15" ||
            (landuse === "16" && "ABC".includes(subuse))
        ) || !isReadOnly) && (
            <DataContainer title="Opening Times">
                <Stack spacing={1}>
                    <Stack direction="row" spacing={1}>
                        <Grid size={6}>
                            <Typography>Monday To Thursday</Typography>
                        </Grid>
                        <Grid size={3}>
                            <ValidatedTextField name="openingTimes.mondayTillThursdayOpening" readOnly={isReadOnly} />
                        </Grid>
                        <Grid size={3}>
                            <ValidatedTextField name="openingTimes.mondayTillThursdayClose" readOnly={isReadOnly} />
                        </Grid>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                        <Grid size={6}>
                            <Typography>Friday</Typography>
                        </Grid>
                        <Grid size={3}>
                            <ValidatedTextField name="openingTimes.fridayOpen" readOnly={isReadOnly} />
                        </Grid>
                        <Grid size={3}>
                            <ValidatedTextField name="openingTimes.fridayClose" readOnly={isReadOnly} />
                        </Grid>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                        <Grid size={6}>
                            <Typography>Saturday</Typography>
                        </Grid>
                        <Grid size={3}>
                            <ValidatedTextField name="openingTimes.saturdayOpen" readOnly={isReadOnly} />
                        </Grid>
                        <Grid size={3}>
                            <ValidatedTextField name="openingTimes.saturdayClose" readOnly={isReadOnly} />
                        </Grid>
                    </Stack>

                    <Stack direction="row" spacing={1}>
                        <Grid size={6}>
                            <Typography>Sunday</Typography>
                        </Grid>
                        <Grid size={3}>
                            <ValidatedTextField name="openingTimes.sundayOpen" readOnly={isReadOnly} />
                        </Grid>
                        <Grid size={3}>
                            <ValidatedTextField name="openingTimes.sundayClose" readOnly={isReadOnly} />
                        </Grid>
                    </Stack>
                </Stack>
            </DataContainer>
        )
    );
}
